import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const COUNTERPARTIES = {
  getCounterpartList: {
    success: "COUNTERPARTIES_GET_ALL_SUCCESS",
    error: "COUNTERPARTIES_GET_ALL_ERROR"
  },
  getOrderCounterpartList: {
    success: "ORDER_COUNTERPARTIES_GET_ALL_SUCCESS",
    error: "COUNTERPARTIES_GET_ALL_ERROR"
  },
  getFarmerConnectiontList: {
    success: "FARMER_CONNECTIONS_GET_ALL_SUCCESS",
    error: "FARMER_CONNECTIONS_GET_ALL_ERROR"
  },
  create: {
    success: "COUNTERPARTIES_CREATE_SUCCESS",
    error: "COUNTERPARTIES_CREATE_ERROR"
  },
  edit: {
    success: "COUNTERPARTIES_EDIT_SUCCESS",
    error: "COUNTERPARTIES_EDIT_ERROR"
  },
  update: {
    success: "COUNTERPARTIES_UPDATE_SUCCESS",
    error: "COUNTERPARTIES_UPDATE_ERROR"
  },
  delete: {
    success: "COUNTERPARTIES_DELETE_SUCCESS",
    error: "COUNTERPARTIES_DELETE_ERROR"
  }
};

export const counterpartyListAction = (harvestYear=harvestYearDetail().name) => {
  return (dispatch,getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
  let url = `/ntrac/counterpart/farmId/${
    userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
  }/?harvestYear=${harvestYear}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = moment(item.updatedAt).format('ll');
          item.type = item.counterpartTypeResponseDTO.name;
        });
        dispatch({ type: COUNTERPARTIES.getCounterpartList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getOnboardcounterpartyListAction = () => {
  return (dispatch,getState) => {
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
  let url = `/ntrac/counterparty/getAllCounterParty/`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: COUNTERPARTIES.getOrderCounterpartList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const getFarmerListConnectionAction = () => {
  return (dispatch,getState) => {
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
  let url = `/ntrac/counterparty/getConnections`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: COUNTERPARTIES.getFarmerConnectiontList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const createCounterPartyAction = partyInfo => {
  let url = `/ntrac/counterpart`;
  return dispatch => {
    globalApiHandler(url, "post", partyInfo)
      .then(response => {
        dispatch({ type: COUNTERPARTIES.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const sendInvite = partyInfo => {
  let url = `/ntrac/invite`;
  return dispatch => {
    globalApiHandler(url, "post", partyInfo)
      .then(response => {

       dispatch({ type: "SERVER_SUCCESS", data:  {message:"Invitation to counterparty sent successfully!"}});
      //  alert(`Invitaion sent to ${partyInfo.name} Successfully`)
      })
      .catch(err => {
        console.log(err,'err')
        dispatch({ type: "SERVER_ERROR", data: err.data });

      });
  };
};export const updateRequest = (partyInfo,connections) => {
  let url = `/ntrac/connection`;
  return dispatch => {
    globalApiHandler(url, "post", partyInfo)
      .then(response => {
       let getOnboardcounterpartyListActionagain = connections?getFarmerListConnectionAction():getOnboardcounterpartyListAction()

       getOnboardcounterpartyListActionagain(dispatch)
      })
      .catch(err => {
        console.log(err,'err')

      });
  };
};
export const editCounterPartyAction = data => {
  return dispatch => {
    dispatch({ type: COUNTERPARTIES.edit.success, data });
  };
};

export const updateCounterPartyAction = partyInfo => {
  let url = `/ntrac/counterpart/${partyInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", partyInfo)
      .then(response => {
        dispatch({ type: COUNTERPARTIES.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteCounterPartyAction = id => {
  let url = `/ntrac/counterpart/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: COUNTERPARTIES.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/counterparties/action.js